import {BaseMenuItem} from '@models/sidebar/response/base-menu-item';
import {MenuItem} from '@models/sidebar/menu-item';

export class PageItem extends BaseMenuItem {
  canBeAltered?: boolean = false;

  /**
   * @deprecated - use firebaseUserId
   */
  userId: number | undefined = undefined;
  firebaseUserId: string | undefined = undefined;
  menuItemParent: MenuItem | undefined = undefined;
  url: string | undefined = undefined;
  formIsActive?: boolean = false;
}
